import { render, staticRenderFns } from "./MarginKpiCard.vue?vue&type=template&id=2d8e1e0e&scoped=true&"
import script from "./MarginKpiCard.vue?vue&type=script&lang=js&"
export * from "./MarginKpiCard.vue?vue&type=script&lang=js&"
import style0 from "./MarginKpiCard.vue?vue&type=style&index=0&id=2d8e1e0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8e1e0e",
  null
  
)

export default component.exports